import {
  MAXIMUM_MESSAGE_LENGTH,
  MAXIMUM_MESSAGE_LENGTH_BY_PROVIDERS_MAP,
} from '../constants';

const getMaximumMessageLength = (provider) =>
  MAXIMUM_MESSAGE_LENGTH_BY_PROVIDERS_MAP[provider] ?? MAXIMUM_MESSAGE_LENGTH;

export { getMaximumMessageLength };
